import React, { useState } from 'react';

const AdminRevenue = ({
    onDashboard,
    onCourseManagement,
    onChapterManagement,
    onQuestionBank,
    onStudentDirectory,
    onParentDirectory,
    onRevenue,
    onLogout
}) => {
    const [isDarkMode, setIsDarkMode] = useState(false);

    const toggleDarkMode = () => {
        setIsDarkMode(!isDarkMode);
        document.documentElement.classList.toggle('dark');
    };

    return (
        <>
            <style>
                {`
                .material-symbols-outlined {
                    font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
                    vertical-align: middle;
                    display: inline-block;
                    line-height: 1;
                    text-transform: none;
                    letter-spacing: normal;
                    word-wrap: normal;
                    white-space: nowrap;
                    direction: ltr;
                }
                ::-webkit-scrollbar {
                    width: 5px;
                }
                ::-webkit-scrollbar-track {
                    background: transparent;
                }
                ::-webkit-scrollbar-thumb {
                    background: rgba(203, 213, 225, 0.5);
                    border-radius: 10px;
                }
                .dark ::-webkit-scrollbar-thumb {
                    background: rgba(51, 65, 85, 0.5);
                }
                ::-webkit-scrollbar-thumb:hover {
                    background: rgba(148, 163, 184, 0.8);
                }
                .dark ::-webkit-scrollbar-thumb:hover {
                    background: rgba(71, 85, 105, 0.8);
                }
                scrollbar-width: thin;
                scrollbar-color: rgba(203, 213, 225, 0.5) transparent;
                `}
            </style>

            <div className={`fixed inset-0 flex overflow-hidden font-sans antialiased ${isDarkMode ? 'dark bg-[#0F172A] text-slate-100' : 'bg-[#F8FAFC] text-slate-900'}`}>
                {/* Sidebar */}
                <aside className="w-64 bg-[#131C2E] text-slate-300 flex-shrink-0 flex flex-col border-r border-slate-800 hidden lg:flex h-full">
                    <div className="p-6 flex items-center gap-3 shrink-0">
                        <div className="w-10 h-10 bg-[#00A669] rounded-lg flex items-center justify-center text-white font-bold text-xl uppercase tracking-tighter shadow-lg shadow-emerald-500/20">H</div>
                        <div>
                            <h1 className="text-white font-bold leading-tight">Master Admin</h1>
                            <p className="text-[10px] text-slate-500 uppercase tracking-widest font-semibold text-nowrap">System Management</p>
                        </div>
                    </div>

                    <nav className="flex-1 px-4 space-y-1 mt-4 overflow-y-auto custom-scrollbar">
                        <button
                            onClick={onDashboard}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">dashboard</span>
                            <span className="font-medium group-hover:text-white transition-colors">Dashboard Overview</span>
                        </button>

                        <div className="pt-4 pb-2 px-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest">Core Content</div>
                        <button
                            onClick={onCourseManagement}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">auto_stories</span>
                            <span className="font-medium group-hover:text-white transition-colors">Course Management</span>
                        </button>
                        <button
                            onClick={onChapterManagement}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">account_tree</span>
                            <span className="font-medium group-hover:text-white transition-colors">Chapter Management</span>
                        </button>
                        <button
                            onClick={onQuestionBank}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">quiz</span>
                            <span className="font-medium group-hover:text-white transition-colors">Question Bank</span>
                        </button>

                        <div className="pt-6 pb-2 px-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest">Directories</div>
                        <button
                            onClick={onStudentDirectory}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">group</span>
                            <span className="font-medium group-hover:text-white transition-colors">Student Directory</span>
                        </button>
                        <button
                            onClick={onParentDirectory}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">family_restroom</span>
                            <span className="font-medium group-hover:text-white transition-colors">Parent Directory</span>
                        </button>

                        <div className="pt-6 pb-2 px-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest">Reports</div>
                        <button
                            className="w-full bg-[#00A669] text-white flex items-center gap-3 px-4 py-3 rounded-xl transition-all shadow-md shadow-emerald-500/20 text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl">monitoring</span>
                            <span className="font-medium">Revenue/Analytics</span>
                        </button>




                    </nav>

                    <div className="p-4 mt-auto border-t border-slate-800 shrink-0">
                        <button
                            onClick={onLogout}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-rose-400 hover:bg-rose-500/10 transition-all group"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl">logout</span>
                            <span className="font-medium group-hover:translate-x-1 transition-transform">Sign Out</span>
                        </button>
                    </div>
                </aside>

                {/* Main Content Area */}
                <div className="flex-1 flex flex-col min-w-0 h-full overflow-hidden">
                    {/* Header */}
                    <header className="h-16 bg-white dark:bg-[#1E293B] border-b border-slate-200 dark:border-slate-800 flex items-center justify-between px-8 sticky top-0 z-20 shrink-0 shadow-sm">
                        <div className="flex-1 max-w-xl">
                            <h2 className="text-xl font-bold dark:text-white">Revenue & Analytics</h2>
                        </div>
                        <div className="flex items-center gap-6 ml-6">
                            <div className="flex items-center gap-2 px-3 py-1.5 bg-emerald-50 dark:bg-emerald-500/10 rounded-lg">
                                <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
                                <span className="text-[10px] font-bold text-emerald-600 dark:text-emerald-400 uppercase">Live Updates</span>
                            </div>
                            <div className="h-8 w-[1px] bg-slate-200 dark:bg-slate-700"></div>
                            <button className="text-slate-500 dark:text-slate-400 hover:text-[#00A669] transition-colors"><span className="material-symbols-outlined">settings</span></button>
                        </div>
                    </header>

                    {/* Scrollable Content */}
                    <main className="flex-1 overflow-y-auto p-8 space-y-8 bg-background-light dark:bg-[#0F172A] pb-24">
                        {/* Page Title & Actions */}
                        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                            <div>
                                <h1 className="text-3xl font-bold tracking-tight text-slate-900 dark:text-white">Financial Insights</h1>
                                <p className="text-slate-500 dark:text-slate-400 mt-1">Real-time performance metrics and historical financial analysis.</p>
                            </div>
                            <div className="flex items-center gap-3">
                                <div className="flex bg-white dark:bg-[#1E293B] border border-slate-200 dark:border-slate-800 rounded-lg p-1 shadow-sm">
                                    <button className="px-3 py-1.5 text-xs font-bold rounded-md bg-[#00A669] text-white">Daily</button>
                                    <button className="px-3 py-1.5 text-xs font-bold rounded-md text-slate-500 hover:bg-slate-50 dark:hover:bg-slate-900 transition-all">Weekly</button>
                                    <button className="px-3 py-1.5 text-xs font-bold rounded-md text-slate-500 hover:bg-slate-50 dark:hover:bg-slate-900 transition-all">Monthly</button>
                                </div>
                                <button className="px-5 py-2.5 rounded-lg bg-slate-900 dark:bg-white text-white dark:text-slate-900 font-bold text-sm hover:scale-[1.02] active:scale-[0.98] transition-all shadow-lg flex items-center gap-2">
                                    <span className="material-symbols-outlined text-[18px]">download</span>
                                    Report
                                </button>
                            </div>
                        </div>

                        {/* Financial Overview Cards */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            <div className="bg-[#1E293B] dark:bg-[#1E293B] rounded-3xl p-6 text-white overflow-hidden relative shadow-xl shadow-slate-200 dark:shadow-none">
                                <div className="absolute -top-6 -right-6 w-32 h-32 bg-emerald-500/10 rounded-full blur-3xl"></div>
                                <div className="relative z-10">
                                    <div className="flex items-center gap-3 mb-6">
                                        <div className="p-2 bg-emerald-500/20 text-emerald-400 rounded-xl"><span className="material-symbols-outlined">payments</span></div>
                                        <span className="text-xs font-bold uppercase tracking-widest text-emerald-400">Net Revenue</span>
                                    </div>
                                    <p className="text-4xl font-black tracking-tight">$42,850.50</p>
                                    <div className="mt-4 flex items-center gap-2">
                                        <span className="flex items-center text-emerald-400 text-xs font-bold"><span className="material-symbols-outlined text-[14px]">trending_up</span> +14.2%</span>
                                        <span className="text-[10px] text-slate-400 font-bold uppercase tracking-tight">vs last month</span>
                                    </div>
                                </div>
                            </div>
                            <div className="bg-[#131C2E] rounded-3xl p-6 text-white shadow-xl shadow-slate-200 dark:shadow-none relative overflow-hidden ring-1 ring-slate-800">
                                <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-blue-500/10 rounded-full blur-2xl"></div>
                                <div className="relative z-10 flex flex-col justify-between h-full">
                                    <div>
                                        <div className="flex items-center gap-3 mb-4">
                                            <div className="p-2 bg-blue-500/20 text-blue-400 rounded-xl"><span className="material-symbols-outlined">shopping_cart</span></div>
                                            <span className="text-xs font-bold uppercase tracking-widest text-blue-400">Total Sales</span>
                                        </div>
                                        <p className="text-3xl font-black tracking-tight">1,245</p>
                                    </div>
                                    <div className="mt-8 flex items-center gap-3">
                                        <div className="flex-1 h-1.5 bg-slate-800 rounded-full overflow-hidden">
                                            <div className="h-full bg-blue-500 w-[78%]"></div>
                                        </div>
                                        <span className="text-[10px] font-bold text-blue-400 uppercase">78% Goal</span>
                                    </div>
                                </div>
                            </div>
                            <div className="bg-white dark:bg-[#1E293B] rounded-3xl p-6 border border-slate-100 dark:border-slate-800 shadow-sm relative group overflow-hidden">
                                <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity">
                                    <span className="material-symbols-outlined text-[100px] text-slate-500">account_balance_wallet</span>
                                </div>
                                <div className="relative z-10">
                                    <div className="flex items-center gap-3 mb-4">
                                        <div className="p-2 bg-slate-50 dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl"><span className="material-symbols-outlined">analytics</span></div>
                                        <span className="text-xs font-bold uppercase tracking-widest text-slate-500">Average Order</span>
                                    </div>
                                    <p className="text-3xl font-black tracking-tight text-slate-900 dark:text-white">$34.42</p>
                                    <div className="mt-4 flex items-center gap-2">
                                        <span className="flex items-center text-rose-500 text-xs font-bold"><span className="material-symbols-outlined text-[14px]">trending_down</span> -2.4%</span>
                                        <span className="text-[10px] text-slate-400 font-bold uppercase tracking-tight">vs last week</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Recent Transactions & Analytics */}
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                            {/* Transactions History */}
                            <div className="bg-white dark:bg-[#1E293B] rounded-3xl border border-slate-200 dark:border-slate-800 shadow-sm overflow-hidden flex flex-col">
                                <div className="p-6 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between">
                                    <div>
                                        <h3 className="font-bold text-lg dark:text-white">Recent Transactions</h3>
                                        <p className="text-xs text-slate-400 font-medium">Last 5 activities across the system</p>
                                    </div>
                                    <button className="text-xs font-bold text-[#00A669] hover:underline">View All</button>
                                </div>
                                <div className="flex-1 overflow-x-auto">
                                    <table className="w-full text-left">
                                        <tbody className="divide-y divide-slate-100 dark:divide-slate-800/50">
                                            {[
                                                { user: 'Robert Johnson', sub: 'Premium Plan (Annual)', amount: '+$199.00', date: 'Just now', initial: 'RJ', color: 'bg-emerald-500' },
                                                { user: 'Elena Williams', sub: 'Course: Advanced Math', amount: '+$45.00', date: '2 hours ago', initial: 'EW', color: 'bg-blue-500' },
                                                { user: 'Mark Davis', sub: 'Wallet Refill', amount: '+$50.00', date: 'Today, 10:45 AM', initial: 'MD', color: 'bg-amber-500' },
                                                { user: 'Jack Miller', sub: 'Premium Upgrade', amount: '+$89.00', date: 'Yesterday', initial: 'JM', color: 'bg-purple-500' },
                                                { user: 'Super Admin', sub: 'System Withdrawal', amount: '-$1,200.00', date: 'Yesterday', initial: 'SA', color: 'bg-slate-800' },
                                            ].map((tx, i) => (
                                                <tr key={i} className="hover:bg-slate-50 dark:hover:bg-slate-800/30 transition-colors group">
                                                    <td className="px-6 py-4">
                                                        <div className="flex items-center gap-3">
                                                            <div className={`w-8 h-8 rounded-lg ${tx.color} flex items-center justify-center text-white text-[10px] font-bold`}>{tx.initial}</div>
                                                            <div>
                                                                <p className="text-sm font-bold text-slate-900 dark:text-white group-hover:text-[#00A669] transition-colors">{tx.user}</p>
                                                                <p className="text-[10px] text-slate-400 font-bold uppercase tracking-tighter">{tx.sub}</p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4 text-right">
                                                        <p className={`text-sm font-black ${tx.amount.startsWith('+') ? 'text-emerald-500' : 'text-slate-400 dark:text-slate-500 line-through'}`}>{tx.amount}</p>
                                                        <p className="text-[10px] text-slate-400">{tx.date}</p>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* Simple Analytic Overview */}
                            <div className="space-y-6">
                                <div className="bg-white dark:bg-[#1E293B] rounded-3xl border border-slate-200 dark:border-slate-800 p-6 shadow-sm">
                                    <h3 className="font-bold text-lg mb-6 dark:text-white">Revenue by Course Category</h3>
                                    <div className="space-y-4">
                                        {[
                                            { label: 'Science & Nature', value: '45%', amount: '$19,282', color: 'bg-[#00A669]' },
                                            { label: 'Mathematics', value: '30%', amount: '$12,855', color: 'bg-blue-500' },
                                            { label: 'Languages', value: '15%', amount: '$6,427', color: 'bg-amber-500' },
                                            { label: 'Others', value: '10%', amount: '$4,285', color: 'bg-slate-400' },
                                        ].map((item, i) => (
                                            <div key={i}>
                                                <div className="flex items-center justify-between mb-1.5">
                                                    <span className="text-xs font-bold text-slate-600 dark:text-slate-300">{item.label}</span>
                                                    <span className="text-xs font-black dark:text-white">{item.amount}</span>
                                                </div>
                                                <div className="h-2 w-full bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden">
                                                    <div className={`h-full ${item.color} transition-all duration-1000`} style={{ width: item.value }}></div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Footer */}
                        <footer className="py-8 border-t border-slate-200 dark:border-slate-800 flex flex-col sm:flex-row items-center justify-between text-slate-400 text-[10px] font-bold uppercase tracking-widest gap-4">
                            <div className="flex items-center gap-2">
                                <div className="w-6 h-6 bg-[#00A669] rounded flex items-center justify-center text-white text-[10px] font-bold">H</div>
                                <span>© 2024 Himigo Platform - Master Admin Console</span>
                            </div>
                        </footer>
                    </main>
                </div>

                {/* Dark Mode Toggle Float */}
                <button
                    onClick={toggleDarkMode}
                    className="fixed bottom-6 right-6 w-12 h-12 rounded-full bg-white dark:bg-[#1E293B] border border-slate-200 dark:border-slate-700 shadow-xl shadow-slate-200/50 dark:shadow-none flex items-center justify-center text-slate-600 dark:text-slate-300 z-[60] hover:scale-110 active:scale-95 transition-all"
                >
                    <span className="material-symbols-outlined">{isDarkMode ? 'light_mode' : 'dark_mode'}</span>
                </button>
            </div>
        </>
    );
};

export default AdminRevenue;
